<template>
  <div class="relative" ref="dropdownRef">
    <!-- Dropdown Button -->
    <div
      class="w-full p-3 rounded-lg bg-dark-grey text-total-white cursor-pointer flex justify-between items-center border border-total-white-100"
      @click="toggleDropdown"
      :class="{ 'opacity-50': disabled }"
    >
      <span>
        <!-- Show selected option label, or placeholder if none -->
        {{ selectedOption ? selectedOption.label : placeholder }}
      </span>
      <i class="fa-solid fa-chevron-down text-total-white-500"></i>
    </div>

    <!-- Options List -->
    <div
      v-if="isOpen"
      class="absolute mt-1 w-full text-left rounded-md shadow-lg bg-dark-grey z-10 max-h-52 overflow-auto border border-total-white-100"
    >
      <ul class="py-1">
        <li
          v-for="option in options"
          :key="option.value"
          @click="selectOption(option)"
          class="cursor-pointer px-4 py-2 border-b border-light-grey-translucent text-total-white"
        >
          {{ option.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { defineProps, defineEmits } from "vue";

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: [String, Number, Object],
    default: "",
  },
  placeholder: {
    type: String,
    default: "Select an option",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["update:modelValue"]);

const isOpen = ref(false);
const dropdownRef = ref(null);

const selectedOption = computed(() => {
  return props.options.find((o) => o.value === props.modelValue);
});

const toggleDropdown = () => {
  if (!props.disabled) {
    isOpen.value = !isOpen.value;
  }
};

const selectOption = (option) => {
  emits("update:modelValue", option.value);
  isOpen.value = false;
};

const handleClickOutside = (event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});
</script>

<style scoped>
/* You can add additional styling here if needed */
</style>
